module.exports = __webpack_public_path__ + "static/media/post1.4c1b4ef1.svg";